import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { Link } from 'react-router-dom';
import './App.css';

const NavBar = () => {
  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged(user => {
      setIsSignedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

return (
<header className="main">
<div className="header-flex"> 
    <div className="header-item">
         <h1> Flow </h1>
    </div>
    <div className="header-item">
        <nav>
          {!isSignedIn && <Link to="/welcome">Sign In</Link>}
          <Link to="/">Home</Link>
          <Link to="/taskbar">Task Bar</Link>
          <Link to="/presets">Color Presets</Link>
        </nav>
    </div>
</div>
</header>
  );
};

export default NavBar;
